import Vehicle from './vehicle'
export default Vehicle
